<template>
    <div class="cp-reqs">
        <EmptyStates v-if="publishedCampaignIds && !publishedCampaignIds.length"/>
        <div v-else>
            <div data-name="card-title">
                <p>Crossprom Requests</p>
                <Icon id="crossprom-requests-hint" class="cursor-pointer" v-b-tooltip.right title="All of the cross-promotion requests that you've sent and received." icon="hint-icon"/>
            </div>
            <div>
                <Card 
                    :data="requests" 
                    :columns="columns"
                    :totalCount = 'totalCount'
                    :loading = "loading"
                    :set-expanded-data = 'setRequestData'
                />
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '../../components/Theme/Icon'
import Card from './components/Card'
import { useRequests} from '../../core/hooks'
import { dashboardUtils } from '../../core/utils';
import EmptyStates from './components/EmptyStates'
import { computed } from '@vue/composition-api';
import store from '../../store';

export default {
    name: 'CpReqs',
    components: {
        Icon,
        Card,
        EmptyStates
    },
    setup(){
        const {
            requests,
            loading,
            totalCount,
            setRequestData
        } = useRequests()    
        const publishedCampaignIds = computed(() => store.state.publishedCampaignIds)
        return {
            requests,
            loading,
            totalCount,
            columns: dashboardUtils.REQUESTS_TABLE_COLUMNS,
            setRequestData,
            publishedCampaignIds
        }
    }
}
</script>
